import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import http from "../api/http";
import { formatDate } from "../utils/format";

const formatPresentacion = (gramos) => {
  const value = Number(gramos || 0);
  if (value >= 1000) return `${(value / 1000).toLocaleString("es-AR")}kg`;
  return `${value.toLocaleString("es-AR")}g`;
};

const titulos = {
  produccion: "Tracking de orden de produccion",
  fraccionado: "Tracking de orden de fraccionamiento",
};

export default function TrackingOrden() {
  const { tipo, codigo } = useParams();
  const [orden, setOrden] = useState(null);
  const [cargando, setCargando] = useState(true);
  const [error, setError] = useState("");

  useEffect(() => {
    const cargar = async () => {
      try {
        setCargando(true);
        setError("");
        const { data } = await http.get(`/operaciones/tracking/${tipo}/${encodeURIComponent(codigo)}`);
        setOrden(data);
      } catch {
        setError("No se encontro informacion para esta orden.");
      } finally {
        setCargando(false);
      }
    };
    cargar();
  }, [tipo, codigo]);

  if (cargando) {
    return <div className="tracking-page"><div className="tracking-loading">Cargando tracking...</div></div>;
  }

  if (error) {
    return <div className="tracking-page"><div className="tracking-error">{error}</div></div>;
  }

  return (
    <div className="tracking-page">
      <div className="tracking-card">
        <div className="tracking-heading">
          <span>Especiar</span>
          <h1>{titulos[orden.tipo] || "Tracking de orden"}</h1>
        </div>
        <div className="tracking-code">{orden.codigo}</div>
        <div className={`tracking-status estado-${orden.estado || "pendiente"}`}>
          Estado <strong>{orden.estado || "pendiente"}</strong>
        </div>

        {orden.tipo === "produccion" ? <Produccion orden={orden} /> : <Fraccionado orden={orden} />}
      </div>
    </div>
  );
}

function Produccion({ orden }) {
  return (
    <>
      <div className="tracking-grid">
        <TrackingItem label="Producto terminado" value={orden.productoTerminado} />
        <TrackingItem label="Fecha produccion" value={formatDate(orden.fecha)} />
        <TrackingItem label="Paquetes 25kg" value={orden.cantidadPaquetes25kg || orden.cantidad} />
        <TrackingItem label="Kg producidos" value={`${orden.kilosProducidos || 0} kg`} />
        <TrackingItem label="Lote / partida" value={orden.lotePartidaNro} />
        <TrackingItem label="Vencimiento" value={formatDate(orden.fechaVencimiento)} />
      </div>
      <section className="tracking-section">
        <h2>Ingredientes</h2>
        <div className="table-wrap inline-table-wrap">
          <table>
            <thead>
              <tr>
                <th>Ingreso</th>
                <th>Materia prima</th>
                <th>Proveedor</th>
                <th>Lote</th>
                <th>Vto</th>
                <th>Kg</th>
              </tr>
            </thead>
            <tbody>
              {(orden.insumos || []).map((item) => (
                <tr key={item._id || item.codigoIngreso}>
                  <td>{item.codigoIngreso || "-"}</td>
                  <td>{item.producto || "-"}</td>
                  <td>{item.proveedor || "-"}</td>
                  <td>{item.lotePartidaNro || "-"}</td>
                  <td>{formatDate(item.fechaVencimiento)}</td>
                  <td>{item.kilosNecesarios || item.kilos || 0} kg</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </section>
    </>
  );
}

function Fraccionado({ orden }) {
  return (
    <>
      <div className="tracking-grid">
        <TrackingItem label="Producto" value={orden.producto} />
        <TrackingItem label="OP origen" value={orden.codigoProduccion} />
        <TrackingItem label="Fecha" value={formatDate(orden.fecha)} />
        <TrackingItem label="Kg a fraccionar" value={`${orden.kilosAFraccionar || orden.cantidad || 0} kg`} />
        <TrackingItem label="Lote / partida" value={orden.lotePartidaNro} />
        <TrackingItem label="Vencimiento" value={formatDate(orden.fechaVencimiento)} />
      </div>
      <section className="tracking-section">
        <h2>Paquetes resultantes</h2>
        <div className="table-wrap inline-table-wrap">
          <table>
            <thead>
              <tr>
                <th>Presentacion</th>
                <th>Paquetes</th>
                <th>Kg totales</th>
              </tr>
            </thead>
            <tbody>
              {(orden.salidas || []).map((item) => (
                <tr key={item._id || item.presentacionGramos}>
                  <td>{formatPresentacion(item.presentacionGramos)}</td>
                  <td>{item.cantidadPaquetes}</td>
                  <td>{item.kilosTotales} kg</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </section>
    </>
  );
}

function TrackingItem({ label, value }) {
  return (
    <div>
      <span>{label}</span>
      <strong>{value || "-"}</strong>
    </div>
  );
}
